import * as Constants from '../../constants.js';

import { useEffect, useState } from 'react';

import { Button } from "react-bootstrap";

import { faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ExternalSystemFormModal from '../../components/admin/externalsystems/ExternalSystemsFormModal.jsx';
import ExternalSystemsDashboardCards from '../../components/admin/externalsystems/ExternalSystemsDashboardCards.jsx';
import ExternalSystemsTable from '../../components/admin/externalsystems/ExternalSystemsTable.jsx';
import ConfirmationModal from '../../components/widget/ConfirmationModal.jsx';
import MessageModal from '../../components/widget/MessageModal.jsx';
import Loading from '../../components/widget/Loading.js';

function ExternalSystemsPage() {
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [externalSystems, setExternalSystems] = useState([]);
    const [externalSystemTypes, setExternalSystemTypes] = useState([]);
    const [statusTypes, setStatusTypes] = useState([]);
    const [selectedExternalSystem, setSelectedExternalSystem] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showMessageModal, setShowMessageModal] = useState(true);

    const handleEdit = (externalsystem) => {
        setSelectedExternalSystem(externalsystem);
        setShowModal(true);
    }

    const handleDelete = (externalSystem) => {
        setSelectedExternalSystem(externalSystem)
        setShowDeleteModal(true)
    }

    const handleDeleteConfirmation = (id) => {
        setShowDeleteModal(false)
        setIsLoading(true);

        const controller = new AbortController();
        const signal = controller.signal;
        const token = localStorage.getItem("token");

        fetch(Constants.EXTERNAL_SYSTEMS_DELETE, {
            method: 'DELETE',
            signal: signal,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',

            },
            body: JSON.stringify({ id: id }),
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(err => { throw err; });
                }
                return response.json();
            })
            .then(responseJson => {
                if (responseJson.status === "success") {
                    setExternalSystems(prevExternalSystems => prevExternalSystems.filter(externalSystem => externalSystem.id !== id));
                } else {
                    console.error('Erro na API:', responseJson.message);
                }
                setSelectedExternalSystem(null);
                setIsLoading(false);
            })
            .catch(error => {
                if (error.name === 'AbortError') return;

                console.error('Erro na requisição de remoção:', error.message || error);
                setIsLoading(false);
            });
    }

    const handleCreate = () => {
        setSelectedExternalSystem(null);
        setShowModal(true)
    }

    const handleSave = (externalSystem) => {
        setIsLoading(true);

        let url = Constants.EXTERNAL_SYSTEMS_CREATE
        let method = 'POST'
        if (externalSystem.id) {
            url = Constants.EXTERNAL_SYSTEMS_UPDATE
            method = 'PUT'
        }
        const controller = new AbortController();
        const signal = controller.signal;

        const token = localStorage.getItem("token");

        fetch(url, {
            method: method,
            signal: signal,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(externalSystem),
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(err => { throw err; });
                }
                return response.json();
            })
            .then(responseJson => {
                if (responseJson.status === "success") {
                    const savedExternalSystem = responseJson.data; // O usuário que veio do banco
                    if (externalSystem.id) {
                        // Se for EDIÇÃO: substitui o usuário antigo pelo novo no array
                        setExternalSystems(prev => prev.map(u => u.id === savedExternalSystem.id ? savedExternalSystem : u));
                    } else {
                        // Se for CRIAÇÃO: adiciona o novo usuário ao final (ou início) da lista
                        setExternalSystems(prev => [...prev, savedExternalSystem]);
                    }

                    // Se preferir recarregar tudo do zero, chame sua função de fetch inicial:
                    // fetchAllExternalSystems(); 
                }
                setIsLoading(false);
            })
            .catch(error => {
                if (error.name === 'AbortError') {
                    return;
                }
                console.error('Erro na requisição:', error.message || error);
                setIsLoading(false);
            });
    };

    useEffect(() => {

        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {

            try {

                setIsLoading(true);

                const token = localStorage.getItem("token");

                const headers = {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'externalsystem/json'
                };

                const [externalsystemsRes] = await Promise.all([
                    fetch(Constants.EXTERNAL_SYSTEMS_LIST, { method: 'GET', signal, headers })
                ]);

                if (!externalsystemsRes.ok) {
                    const err = await externalsystemsRes.json();
                    throw err;
                }

                const externalsystemsJson = await externalsystemsRes.json();

                if (externalsystemsJson.status === "success") {
                    setExternalSystems(externalsystemsJson.data);
                }
            } catch (error) {

                if (error.name !== 'AbortError') {
                    console.error(error);
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();

        return () => controller.abort();
    }, []);

    return <>
        <div className="container">
            {!isLoading &&
                <>
                    <div className="d-flex justify-content-between mb-4">

                        <h3 style={{ color: '#fff' }}>Gerenciamento de Sistemas Externos</h3>

                        <Button onClick={handleCreate}>
                            <FontAwesomeIcon icon={faPlus} /> Novo Sistema
                        </Button>

                    </div>
                    <ExternalSystemsDashboardCards externalsystems={externalSystems}/>
                    <ExternalSystemsTable
                        externalSystems={externalSystems}
                        externalSystemTypes={externalSystemTypes}
                        statusTypes={statusTypes}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                    />
                    <ExternalSystemFormModal show={showModal} onHide={() => setShowModal(false)} onSave={handleSave} externalSystem={selectedExternalSystem} />
                </>
            }
            {isLoading && <>
                <Loading />
            </>}

            {showDeleteModal && <ConfirmationModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                onConfirm={handleDeleteConfirmation}
                title="Remover Licença"
                message={<p>Tem certeza que deseja excluir a aplicação <strong>{selectedExternalSystem?.title}</strong><strong>{selectedExternalSystem?.device}</strong>?</p>}
                confirmText="Excluir Agora"
                confirmVariant="danger"
                icon={faTrash}
                isLoading={isLoading}
                id={selectedExternalSystem.id}
            />
            }

            <MessageModal
                show={showMessageModal}
                onHide={() => setShowDeleteModal(false)}
                onConfirm={handleDeleteConfirmation}
                title="Remover Licença"
                message={<p>Tem certeza que deseja excluir a aplicação <strong>{selectedExternalSystem?.title}</strong><strong>{selectedExternalSystem?.device}</strong>?</p>}
                confirmText="Excluir Agora"
                confirmVariant="danger"
                icon={faTrash}
                isLoading={isLoading}
                // id={selectedExternalSystem.id}
            />
                      
        </div>
    </>
}

export default ExternalSystemsPage;